import axios from 'axios';
import { OEmbedVideoResponse } from '../models/oembed';

interface TikTokOEmbedResponse extends OEmbedVideoResponse {
  thumbnail_url?: string;
  thumbnail_width?: number;
  thumbnail_height?: number;
}

const getClip = async (id: string): Promise<TikTokOEmbedResponse | undefined> => {
  try {
    const url = `https://www.tiktok.com/video/${id}`;
    const { data } = await axios.get(
      `https://www.tiktok.com/oembed?url=${encodeURIComponent(url)}`
    );
    return data;
  } catch (error) {
    console.error('TikTok API error:', error);
    return undefined;
  }
};

const tiktokApi = { getClip };
export default tiktokApi;
